import { useMap } from '@vis.gl/react-google-maps';
import React, { useEffect } from 'react';
import { getLatLng } from './utils';

const MapHandler = ({ place, locations = [] }) => {
    const map = useMap();

    useEffect(() => {
        if (!map || !place) return;

        if (locations?.length) {
            const bounds = new window.google.maps.LatLngBounds();
            locations.forEach((location) => {

                const locationPoint = getLatLng(location)
                if (locationPoint) {
                    bounds.extend(locationPoint);
                }
            });

            bounds.extend(place.geometry?.location);
            map.fitBounds(bounds, 80);
        } else if (place.geometry?.viewport) {
            map.fitBounds(place.geometry?.viewport, 100);
        }
    }, [map, place, locations]);

    return null;
};

export default React.memo(MapHandler);
